import { render } from "./CustomReports.vue?vue&type=template&id=abef1bc4&scoped=true"
import script from "./CustomReports.vue?vue&type=script&lang=js"
export * from "./CustomReports.vue?vue&type=script&lang=js"

import "./CustomReports.vue?vue&type=style&index=0&id=abef1bc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abef1bc4"]])

export default __exports__